
// mediastack.js
class MediastackAPIManager {
    constructor() {
        this.apiKey = null;
    }

    async initialize() {
        this.apiKey = await this.fetchApiKey();
        this.newsUrl = `https://api.mediastack.com/v1/news?keywords={ticker}&countries=us&languages=en&access_key=${this.apiKey}`;
    }

    async fetchApiKey() {
        try {
            const response = await fetch('/api/config');
            if (!response.ok) throw new Error(`Failed to fetch /api/config: ${response.status}`);
            const config = await response.json();
            if (!config.MEDIASTACK_API_KEY) throw new Error('MEDIASTACK_API_KEY not found in /api/config');
            //console.log('MEDIASTACKAPIManager initialized, API key:', config.MEDIASTACK_API_KEY.slice(0, 4) + '...');
            return config.MEDIASTACK_API_KEY;
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('Error fetching API key:', error.message);
            throw error;
        }
    }

    static async create() {
        if (!MediastackAPIManager.instance) {
            const instance = new MediastackAPIManager();
            await instance.initialize();
            MediastackAPIManager.instance = instance;
        }
        return MediastackAPIManager.instance;
    }

    async fetchStockNews(stockSymbol, limit = 10, startDate = null, endDate = null) {
        try {
            if (!this.apiKey) throw new Error("MediastackAPI key not initialized.");

            let url = `/proxy-news-mediastack?symbol=${encodeURIComponent(stockSymbol)}&limit=${limit}`;

            if (startDate) url += `&from=${startDate}`; // MediastackAPI uses from/to, not published_utc.gte/lte
            if (endDate) url += `&to=${endDate}`;

            if (__LOG_INFO__) AppLog.info(`📡 Fetching news for ${stockSymbol} from Mediastack.com...`, url);

            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const jsonData = await response.json();
            if (!jsonData.data || !Array.isArray(jsonData.data)) { // MediastackAPI uses "data", not "results"
                if (__LOG_WARN__) AppLog.warn(`❌ No news data available or invalid 'articles' field for ${stockSymbol}.`);
                return [];
            }

            const newsArticles = jsonData.data.map(article => ({
                title: article.title || "No title available",
                publisher: article.source || "Unknown publisher",
                publishedDate: article.published_at || new Date().toISOString(), // publishedAt, not published_utc
                url: article.url || "#", // url, not article_url
                description: article.description || "",
                tickers: [stockSymbol] // MediastackAPI doesn’t provide tickers, so we use the queried symbol
            }));

            if (__LOG_INFO__) AppLog.info(`✅ Retrieved ${newsArticles.length} news articles for ${stockSymbol} from Mediastack.com.`);
            return newsArticles;
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error(`❌ Error fetching news for ${stockSymbol}: ${error.message}`);
            return [];
        }
    }
}

window.MediastackAPIManager = MediastackAPIManager;
